import React from 'react';
import CommentModel from '../../../models/CommentModel';
import FormatUtils from '../../../utils/FormatUtils';

interface IProps {
    comment: CommentModel
}

const CommentView: React.FC<IProps> = ({ comment }) => {
    const utils = new FormatUtils()

    const postedOn = utils.formatDateTime(comment.postedOn)

    return (
        <div className='row' style={{ border: '1px solid #e3e3e3', margin: 5, borderRadius: 10 }}>
            <div className='user' style={{ backgroundColor: '#e3e3e3', borderTopLeftRadius: 10, borderTopRightRadius: 10 }}>
                <div className='thumbnail'><img height='32' src={comment.postedBy_UserThumbnailUrl} /></div>
                <div style={{ marginTop: 5, marginLeft: 3, float: 'left' }}>
                    {comment.postedBy_Username}
                </div>
                <div style={{ marginTop: 5, marginLeft: 3, float: 'right' }}>
                    {postedOn}
                </div>
            </div>
            <div>
                {comment.text}
            </div>
        </div>
    );
}
export default CommentView